import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import Gleap from 'gleap';

Gleap.initialize(environment.gleapApiKey);
// API keys requests/responses carry the plaintext key (POST 201): keep them out
// of Gleap's network log capture. Substring match.
Gleap.setNetworkLogsBlacklist(['/users/me/api-keys']);
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));